/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pol_Scenario_A_DescInputs */

const en_pol_scenario_a_desc = /** @type {(inputs: Pol_Scenario_A_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The official agent on your computer, started by Bystep on that computer.`)
};

const id_pol_scenario_a_desc = /** @type {(inputs: Pol_Scenario_A_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen resmi di komputer kamu, dijalankan oleh Bystep di komputer itu.`)
};

/**
* | output |
* | --- |
* | "The official agent on your computer, started by Bystep on that computer." |
*
* @param {Pol_Scenario_A_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_scenario_a_desc = /** @type {((inputs?: Pol_Scenario_A_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_Scenario_A_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_scenario_a_desc(inputs)
	return en_pol_scenario_a_desc(inputs)
});